/* eslint-disable @typescript-eslint/no-empty-function */
import { Box, Dialog, DialogActions, DialogTitle, IconButton, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MailOutLineIcon from '@material-ui/icons/MailOutline';
import { ArrowButton } from 'components';
import { Theme } from 'enum';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => {
    return {
        dialog: {
            minWidth: '500px',
            transition: '.5s',
            [theme.breakpoints.down('xs')]: {
                minWidth: '90%',
            },
        },
        dialogHeader: {
            padding: '20px 15px',
            margin: 20,
            fontSize: '17px',
            fontWeight: 'lighter',
            letterSpacing: '.5px',
            borderBottom: `${theme.palette.type === Theme.Light ? '.5px solid #ddd' : '.5px solid #3a3a3a'}`,
            color: `${theme.palette.type === Theme.Light ? '#424242' : '#fff'}`,
            [theme.breakpoints.up('md')]: {
                padding: '25px 20px',
                fontSize: '20px',
            },
        },
        email: {
            display: 'flex',
            alignItems: 'center',
            color: `${theme.palette.type === Theme.Light ? '#616161' : '#ddd'}`,
            textDecoration: 'none',
            padding: '15px',
            transition: '.5s',
            '&:hover': {
                backgroundColor: `${theme.palette.type === Theme.Light ? '#ddd' : '#333'}`,
            },
            '&:active': {
                backgroundColor: `${theme.palette.type === Theme.Light ? '#bbb' : '#2a2a2a'}`,
                color: `${theme.palette.type === Theme.Light ? '#414141' : '#fff'}`,
            },
            [theme.breakpoints.up('md')]: {
                padding: '20px',
                fontSize: '16px',
            },
        },
        sendToAllButton: {
            textDecoration: 'none',
            width: '100%',
            padding: theme.spacing(2),
            borderRadius: 8,
            fontSize: 16,
            textAlign: 'center',
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
            transition: '.3s',
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
    };
});

export type ApplyFormProps = {
    emails: Array<string> | null | undefined;
    title: string;
};

export const ApplyForm: React.FC<ApplyFormProps> = ({ emails, title }) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const classes = useStyles();

    const formattedBody = window.location.href;
    const mailToLink = encodeURIComponent(formattedBody);

    const emailBody = `
        %0D
        %0D
        %0D
        ${t('jobDetails:goToJob_android', { jobUrl: mailToLink })}
        %0D
        %0D
        ${t('common:downloadMessage')}
        %0D
        ${'https://staffy.app.link'}
  `;

    return (
        <>
            {emails && emails.length === 1 && (
                <ArrowButton
                    style={{
                        padding: '18px 20px',
                        fontSize: '20px',
                    }}
                    text={t('jobDetails:apply')}
                    hasIcon={false}
                    disableRipple={false}
                    href={`mailto:${emails[0]}?subject=${title}&body=${emailBody}`}
                />
            )}
            {emails && emails.length > 1 && (
                <ArrowButton
                    style={{
                        padding: '18px 20px',
                        fontSize: '20px',
                    }}
                    text={t('jobDetails:apply')}
                    hasIcon={false}
                    disableRipple={false}
                    href={'#'}
                    onClick={(): void => {
                        setOpen(true);
                    }}
                />
            )}
            <Dialog classes={{ paper: classes.dialog }} open={open} onClose={(): void => setOpen(false)}>
                <DialogTitle style={{ padding: 16 }} disableTypography>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        {t('jobDetails:apply')}
                        <IconButton onClick={(): void => setOpen(false)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                {emails &&
                    emails.map((email) => (
                        <a
                            key={email}
                            href={`mailto:${email}?subject=${title}&body=${emailBody}`}
                            className={classes.email}
                        >
                            <MailOutLineIcon style={{ marginRight: '15px' }} />
                            <span>{email}</span>
                        </a>
                    ))}
                <DialogActions>
                    <a
                        className={classes.sendToAllButton}
                        href={`mailto:${
                            emails && emails.map((email) => `${email}`)
                        }?subject=${title}&body=${emailBody}`}
                    >
                        {t('jobDetails:sendToAll')}
                    </a>
                </DialogActions>
            </Dialog>
        </>
    );
};
